import { useEffect, useState } from "react";
import useScreenDimension from "./useScreenDimension";

const useObtenerLogoHeader= () => {
    const { width } = useScreenDimension();
    const [logoLN, setLogoLN] = useState('');
    const widthLimiteMobile = 767;

    useEffect(() => {
        if (width <= widthLimiteMobile) {
            setLogoLN('ln')
        } else {
            setLogoLN('la-nacion')

        }
    }, [width]);
    
    return logoLN;
}

export default useObtenerLogoHeader;